import * as _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { Tab } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// MUI import
import { Box } from '@mui/material'
// Project imports
import { KNOWLEDGE_ARCHIVED, REVIEW_QUIZ_QUESTIONS } from '@/config'
import '@/routes/Knowledge/AllKnowledge/AllKnowledge.scss'
import UploadedDocuments from '@/routes/UploadedDocuments/UploadedDocuments'
import { getCommonState, getIsSuperAdmin } from '@/store/common/selector'
import { bulkAssignModules } from '@/store/knowledge/actions'
import { getAgentFeatures } from '@/store/common/actions'
import {
  isAllKnowledgeSuccess,
  isTopicsLoading,
} from '@/store/knowledge/selector'
import { getAllUserGroupOptions } from '@/store/notifications/actions'
import { getAllIntents as getAllIntentsSelector } from '@/store/questions/selector'
import Loading from '@/components/UI/Loading/Loading'
import MoveSelectedModal from './MoveSelectedModal'
import integrationService from '@/services/IntegrationService'
import LearningOutcomes from './LearningOutcomes'
import SharepointUrls from '@/components/UI/KnowledgeDatatableComponent/SharepointUrls'
import KGroupsTree from '@/components/UI/KGroupsTree'
import CustomTabs from '@/components/UI/CustomTabs'
import FlashCards from './FlashCards'
import LessonPlan from './LessonPlan'

function KnowledgeDatatableComponentGridView(props: any) {
  const { t } = useTranslation('translation')
  const commonState = useSelector(getCommonState)
  const isSuperadmin = useSelector(getIsSuperAdmin)
  const history: any = useHistory()
  const dispatch = useDispatch()
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [perPage, setPerPage] = useState(30)
  const [currentPage, setCurrentPage] = useState(1)
  const allKnowledgeSuccess = useSelector(isAllKnowledgeSuccess)
  const topicsLoading = useSelector(isTopicsLoading)
  const allIntents = useSelector(getAllIntentsSelector)
  const [activeKey, setActiveKey] = useState(null)
  const [showsSpSettings, setShowsSpSettings] = useState(false)
  const [isLessonPlanEnabled, setIsLessonPlanEnabled] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selectedDoc, setSelectedDoc] = useState([])

  // handle active tab
  const defaultTab = history.location.state?.activeTab || 'viewDocument'
  const validTabs = [
    'viewDocument',
    'viewKnowledge',
    'viewLearningOutcomes',
    'viewSharePointSettings',
    'viewLessonPlan',
  ]
  const [activeTab, setActiveTab] = useState(defaultTab)

  useEffect(() => {
    if (!topicsLoading) {
      dispatch(getAllUserGroupOptions()) // user groups
    }
    setSelectedNodes([])

    if (isSuperadmin) {
      checkShowSpFolders()
    }

    // Check if lesson_plan feature is enabled
    const checkFeatures = async () => {
      const features: any = await dispatch(getAgentFeatures())
      const lessonPlanFeature = features?.find(
        (feature: any) => feature.name === 'lesson_plan',
      )
      setIsLessonPlanEnabled(lessonPlanFeature?.status === 'active')
    }
    checkFeatures()
  }, [])

  useEffect(() => {
    if (
      selectedGroup?.group_type === 'system' &&
      (activeTab === 'viewLearningOutcomes' ||
        activeTab === 'viewSharePointSettings')
    ) {
      const nextTab = defaultTab || 'viewDocument'
      setActiveTab(nextTab)
    }
  }, [selectedGroup, activeTab])

  const checkShowSpFolders = async () => {
    const { status, data } = await integrationService.getIntegrations(
      'azure',
      'api',
    )
    if (status === 200) {
      // Check if data.data.integrations is available then loop through integrations
      if (data?.data?.integrations && data?.data?.integrations.length > 0) {
        setShowsSpSettings(true)
      }
    }
  }

  /**
   * State to manage tags | categories as Nodes | Tags whatever we can say
   */
  const [selectedNodes, setSelectedNodes] = useState([])
  const [query, setQuery] = useState('')

  /**
   * Used to sort data using API
   * @param param0
   * @param direction
   */

  // Show bulk assign category modal
  const [bulkAssignCategoryShow, setBulkAssignCategoryShow] = useState(false)
  const BulkAssignCategoryhandler = (value: boolean) => {
    setBulkAssignCategoryShow(value)
  }
  const bulkAssignCategoryKnowledgeHandler = () => {
    setBulkAssignCategoryShow(true)
  }

  const confirmCategoryUpdateHandler = async (selectedOption: any) => {
    try {
      BulkAssignCategoryhandler(false)
      await dispatch(bulkAssignModules(selectedOption, selectedNodes))
      setSelectedNodes([])
    } catch (error: any) {
      setSelectedNodes([])
    }
  }

  const addToSelectedRows = (event: any, id: string) => {
    let data: any[] = [...selectedNodes]
    if (event.target.checked) {
      const isPresent = data.indexOf(id)
      if (isPresent < 0) {
        data.push(id)
      }
    } else {
      const oldData = [...selectedNodes]
      const index = oldData.indexOf(id)
      oldData.splice(index, 1)
      data = [...oldData]
    }
    setSelectedNodes([..._.uniq(data)])
  }

  const onSelectAllRows = (event: any) => {
    if (event.target.checked) {
      if (
        allKnowledgeSuccess &&
        allKnowledgeSuccess.intents &&
        allKnowledgeSuccess.intents.length > 0
      ) {
        let data: any[] = [
          ...allKnowledgeSuccess.intents.map((intent: any) => intent._id),
        ]
        setSelectedNodes([..._.uniq(data)])
      }
    } else {
      setSelectedNodes([])
    }
  }

  if (loading) {
    return <Loading />
  }

  return (
    <>
      <MoveSelectedModal
        show={bulkAssignCategoryShow}
        onHide={() => BulkAssignCategoryhandler(false)}
        confirmCategoryUpdate={confirmCategoryUpdateHandler}
      />

      <div>
        {/*TODO move this out of this component*/}
        {props.createFromUploadedDocument && (
          <div className="levels-row mb-4 d-flex">
            <div className="ml-auto text-nowrap">
              {' '}
              <button
                className="btn btn-primary font-400 font-16 p-1 px-3"
                onClick={() => {
                  const queTypes =
                    props.queTypes && props.queTypes.length > 0
                      ? `&queTypes=${props.queTypes.join(',')}`
                      : ''
                  const quizId =
                    props.isEditQuiz && props.quizId
                      ? `&quizId=${props.quizId}`
                      : ''
                  let docs =
                    props.document_Id && props.document_Id.length > 0
                      ? [...props.document_Id]
                      : []
                  if (docs && docs.length > 0) {
                    docs.unshift(selectedDoc[0])
                  }
                  const documents =
                    docs && docs.length > 0 ? [...docs] : selectedDoc
                  history.push(
                    REVIEW_QUIZ_QUESTIONS +
                      `?document=${documents.join(
                        ',',
                      )}${quizId}${queTypes}&reference=add-new`,
                    {
                      createFromUploadedDocument:
                        props.isEditQuiz && props.quizId
                          ? !props.createFromUploadedDocument
                          : props.createFromUploadedDocument,
                      queryString: props.selectedGroupIdForDocument
                        ? '?group=' + props.selectedGroupIdForDocument
                        : `?group=${commonState.selectedGroupId}&parent=${
                            commonState.selectedYear
                              ? commonState.selectedYear._id
                              : ''
                          }`,
                      isEditQuiz: props.isEditQuiz,
                      quizId: props.quizId,
                      questionBank: props.questionBank,
                    },
                  )
                }}
                disabled={selectedDoc?.length === 0}
              >
                {t('View Generated Knowledge')}
              </button>
            </div>
          </div>
        )}

        <div className="tw-flex">
          <KGroupsTree
            syncsState={true}
            actions={{ add: true, edit: true, delete: true }}
            archivedRoute={KNOWLEDGE_ARCHIVED}
            showsManageGroups={true}
            slotProps={{ root: { className: 'tw-w-2/12' } }}
            onSelectGroup={group => {
              setSelectedGroup(group)
            }}
          />
          <div className="tw-w-10/12 tw-pl-0">
            <Box
              className="tw-px-4 tw-py-2"
              sx={{ '& nav': { display: 'inline-flex' } }}
            >
              <CustomTabs
                defaultActiveKey={defaultTab}
                activeKey={
                  props.createFromUploadedDocument ? 'viewDocument' : activeTab
                }
                validTabs={validTabs}
                queryParamName="activeTab"
                onTabChange={key => setActiveTab(key)}
              >
                <Tab eventKey="viewDocument" title={t('Documents')}>
                  {activeTab === 'viewDocument' && (
                    <UploadedDocuments
                      isArchived={false}
                      queryString={
                        props.selectedGroupIdForDocument
                          ? '?group=' + props.selectedGroupIdForDocument
                          : `?group=${selectedGroup?._id}&parent=${
                              commonState.selectedYear
                                ? commonState.selectedYear._id
                                : ''
                            }`
                      }
                      selectedGroupId={selectedGroup?._id}
                      createFromUploadedDocument={
                        props.createFromUploadedDocument
                      }
                      isContexualised={false}
                      isEditQuiz={props.isEditQuiz}
                      quizId={props.quizId}
                      buildV2={props.buildV2}
                      buildKnowledge={props.hideTabs}
                      toolkitQuestionTypes={props.toolkitQuestionTypes}
                      toolkitQuizId={props.toolkitQuizId}
                      toolkitSelectedGroupId={props.toolkitSelectedGroupId}
                      showAllDocuments={props.showAllDocuments}
                      setSelectedDoc={setSelectedDoc}
                      addMoreQuestionFromDocument={
                        props.addMoreQuestionFromDocument
                      }
                      flowKey={props.flowKey}
                      popupProperties={props.popupProperties}
                    />
                  )}
                </Tab>

                {!props.createFromUploadedDocument && !props.hideTabs && (
                  <Tab eventKey="viewKnowledge" title={t('Flash Cards')}>
                    {activeTab === 'viewKnowledge' && (
                      <FlashCards
                        allKnowledgeSuccess={allKnowledgeSuccess}
                        allIntents={allIntents}
                        selectedNodes={selectedNodes}
                        selectedGroup={selectedGroup}
                        currentPage={currentPage}
                        perPage={perPage}
                        activeKey={activeKey}
                        query={query}
                        documentId={props.documentId}
                        onSelectAllRows={onSelectAllRows}
                        addToSelectedRows={addToSelectedRows}
                        bulkAssignCategoryKnowledgeHandler={
                          bulkAssignCategoryKnowledgeHandler
                        }
                        setActiveKey={setActiveKey}
                        setSelectedNodes={setSelectedNodes}
                        setLoading={setLoading}
                        setCurrentPage={setCurrentPage}
                        setPerPage={setPerPage}
                        setQuery={setQuery}
                      />
                    )}
                  </Tab>
                )}

                {selectedGroup?.group_type !== 'system' &&
                  !props.createFromUploadedDocument &&
                  !props.hideTabs && (
                    <Tab
                      eventKey="viewLearningOutcomes"
                      title={t('Learning Outcomes')}
                    >
                      {activeTab === 'viewLearningOutcomes' && (
                        <LearningOutcomes groupId={selectedGroup?._id} />
                      )}
                    </Tab>
                  )}

                {selectedGroup?.group_type !== 'system' &&
                  showsSpSettings &&
                  !props.createFromUploadedDocument &&
                  !props.hideTabs && (
                    <Tab
                      eventKey="viewSharePointSettings"
                      title={t('SharePoint URLs')}
                    >
                      {activeTab === 'viewSharePointSettings' && (
                        <SharepointUrls groupId={selectedGroup?._id} />
                      )}
                    </Tab>
                  )}

                {selectedGroup?.group_type !== 'system' &&
                  isLessonPlanEnabled &&
                  !props.createFromUploadedDocument &&
                  !props.hideTabs && (
                    <Tab eventKey="viewLessonPlan" title={t('Lesson Plan')}>
                      {activeTab === 'viewLessonPlan' && (
                        <LessonPlan groupId={selectedGroup?._id} />
                      )}
                    </Tab>
                  )}
              </CustomTabs>
            </Box>
          </div>
        </div>
      </div>
    </>
  )
}

export default KnowledgeDatatableComponentGridView
